<template>
  <header>
    <b-navbar toggleable="md" type="dark" fixed="top" variant="user">
      <b-container>
        <b-navbar-brand href="#"
          ><img src="@/images/BCnavbar.png"
        /></b-navbar-brand>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav toggleable="false">
            <b-nav-item :to="{ name: 'home' }" exact
              ><fa-icon :icon="['far', 'home']" size="lg" /> Home</b-nav-item
            >
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#" @click="login" v-if="!user.isAuthenticated"
              >Accedi</b-nav-item
            >
            <b-nav-item-dropdown v-else :text="user.name">
              <b-dropdown-item :to="privateAreaUrl"
                >Area Utente</b-dropdown-item
              >
              <b-dropdown-item href="#">Profilo Utente</b-dropdown-item>
              <b-dropdown-item href="#">Cambio Password</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item href="#" @click="logout()">Esci</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </header>
</template>

<script>
import userAuth from "../../mixins/userAuth.js";
import authenticationService from "../../services/AuthenticationService.js";

export default {
  name: "NavbarPublic",
  mixins: [userAuth],
  computed: {
    privateAreaUrl() {
      return isNaN(this.user.name) ? { name: "adminHome" } : { name: "home" };
    },
    username() {
      return this.$store.state.userName;
    },
  },
  methods: {
    login() {
      authenticationService.login();
    },
    logout() {
      authenticationService.logout();
    },
  },
};
</script>
